import React from 'react';
import './OrderCard.less';
import {OrderCardTitle} from "../../elements/order-card-title/OrderCardTitle";
import {OrderCardStatus} from "../../elements/order-card-status/OrderCardStatus";
import {OrderCardPrice} from "../../elements/order-card-price/OrderCardPrice";
import {OrderCardItems} from "../../elements/order-card-items/OrderCardItems";

export const OrderCard = (
	{
		restaurantName,
		itemsString,
		totalPrice,
		status,
		date,
		indicatorControl = null,
		actionControl = null
	}
) => {
	return <div className="order-card">
		<div className="order-card__top-row">
			<div className="order-card__restaurant-name">
				<OrderCardTitle text={restaurantName} />
			</div>
			<div className="order-card__total-price">
				<OrderCardPrice price={totalPrice} />
			</div>
			{
				indicatorControl && (<div className="order-card__indicator">
					{indicatorControl}
				</div>)
			}
		</div>
		<div className="order-card__bottom-row">
			<div className="order-card__status-date-container">
				<div className="order-card__items-string">
					<OrderCardItems text={itemsString}/>
				</div>
				<div className="order-card__status">
					<OrderCardStatus
						status={status}
						title={date}
						/>
				</div>
			</div>
			<div className="order-card__action-control">
				{actionControl}
			</div>
		</div>
	</div>
}
